import React from 'react';
import { Box } from '@mui/material';
import { isFProject } from 'config/project';
import { CarModel, ExportType } from 'models/StockModel';


type ProblemMarkProps = {
    car: CarModel,
}
const ProblemMark = ({car}: ProblemMarkProps) => {
    if (car.exportType === ExportType.Car && !car.damaged)
        return null;

    let symbol = '';
    if (!car.exportType)
        symbol = '?';
    else if (car.exportType === ExportType.DisCar)
        symbol = 'R';
    else if (car.exportType === ExportType.CutRCar)
        symbol = 'CR';
    else if (car.exportType === ExportType.CutFCar)
        symbol = 'CF';
    else if (car.exportType === ExportType.Parts)
        symbol = 'P';

    return <Box component="strong" color="error.light">{!!car.damaged && !isFProject && 'DMG'} {symbol}</Box>;
};

export default ProblemMark;
